import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { ManualJournalSection } from '@/features/ledger/manual-journal'

/**
 * Raising a journal by hand, as an addressable screen of its own.
 *
 * Separated because it has a different audience and a different risk from reading journals: the
 * person who raises one is doing month-end adjustments, and the person reading the enquiry beside it
 * is answering a question. Keeping them apart also keeps the write behind its own gate and its own
 * width refusal.
 *
 * The whole screen refuses below `lg` — money is keyed here, and `docs/mobile-policy.md` names this
 * exact screen as the case the rule was written for.
 */
export function LedgerManualJournalPage() {
  return (
    <>
      <Link
        to="/ledger"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All of the ledger
      </Link>

      <PageHeader
        title="Manual journal"
        description="The highest-privilege write in the system: a movement between any two accounts on one person's authority. It is countersigned, it must balance, and it needs a wide screen."
      />

      <ManualJournalSection />
    </>
  )
}
